//initialize the context here
import {createContext} from 'react'

const movieContext =  createContext()
export default movieContext

//export default createContext();